import factory from '../requestFactory';
import store from "@/store";

export default async({visit_id}) => {
    let params = {
        patient_id:store.getters.patient.id
    }

    return factory()
        .get(`/patient/visits/${visit_id}/payment`,{params:params});
}
